<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="trash-delete-bin"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <g id="Group_727" data-name="Group 727" transform="translate(11.25 7.938)">
      <path
        id="Path_8090"
        data-name="Path 8090"
        d="M34.25,10.282H36.5M14,19.148V32.782m6.75-16.245V35.145m6.75-16V32.782m1.789,8.869H12.211A4.961,4.961,0,0,1,7.25,36.691V10.278h27V36.691A4.961,4.961,0,0,1,29.289,41.652Zm.461-31.374-1.66-5.186a2.252,2.252,0,0,0-2.142-1.564H15.553A2.247,2.247,0,0,0,13.41,5.092l-1.66,5.186m-6.75,0H7.25"
        transform="translate(-5 -3.528)"
        fill="none"
        :stroke="clr ? clr : `#56606B`"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3.5"
      />
    </g>
    <path id="Path_8091" data-name="Path 8091" d="M0,0H54V54H0Z" fill="none" />
  </svg>
</template>
